export enum IHubCatalogVisibility {
  Private = "Private",
  Company = "Company",
  Platform = "Platform",
  /* Global = "Global", */
}
